/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-05-12 15:05:11
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-10-16 18:34:00
 * @FilePath: /designcenter/src/store/user.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
//	具体业务相关类型，需要业务相关人员补充，比如下列any类型，需要替换成具体类型
import { defineStore } from 'pinia'
import { getUserInfo, getUserType } from '@/api/modules/user'
import { getDataCache } from '@/utils'
import { useProductSelectionStore } from './productSelection'
const cache = getDataCache()
interface UserState {
  isLogin: number
  isFirstLogin: number
  userInfo: any
  isCNRegion: boolean
  managerInfo: any
  system_messages: any
  isShowMore: boolean
  systemMessagesUnread: number
  systemMessages: any[]
  companyInfo: any
  isCompanyAccount: boolean
  showPoInvoice: boolean
  isFetch: boolean
  customersEmailAddress: string
  customersFirstname: string
  customersId: number
  customersLastname: string
  customersTelephone: string
  customersType: string
}
export const useUserStore = defineStore('user', {
  state: (): UserState => {
    return {
      isLogin: 0, // 登录状态 0：未登录   1：已登录,
      isFirstLogin: 0, // 是否是第一次登录
      userInfo: { isCompanyOrganizationUser: null }, // 用户信息
      isCNRegion: false,
      managerInfo: null,
      system_messages: null,
      isShowMore: false,
      systemMessagesUnread: 0,
      systemMessages: [],
      companyInfo: {},
      isCompanyAccount: false,
      showPoInvoice: false,
      isFetch: false,
      customersEmailAddress: '',
      customersFirstname: '',
      customersId: 0,
      customersLastname: '',
      customersTelephone: '',
      customersType: '',
    }
  },
  getters: {
    isFeisuEmail: state => {
      return /@(feisu\.com|fs\.com)$/.test(state.customersEmailAddress)
    },
  },
  actions: {
    getUser() {
      getUserInfo()
        .then((res: any) => {
          if (res?.code === 200) {
            this.isLogin = res.data.isLogin
            this.isFirstLogin = res.data.isFirstLogin
            this.userInfo = res.data.user || null
            this.managerInfo = res.data.managerInfo || null
            this.isCNRegion = res.data.isCNRegion
            this.systemMessagesUnread = res.data.system_messages?.is_list_un_read
            this.systemMessages = res.data.system_messages?.messages
            this.isShowMore = res.data.isShowMore
            this.companyInfo = res.data.user?.companyInfo
            this.isCompanyAccount = res.data.user?.isCompanyOrganizationUser
            this.showPoInvoice = res.data.user?.showPoInvoice
          }
        })
        .catch(error => {})
    },
    getCustomerType() {
      return getUserType()
        .then((res: any) => {
          if (res?.code === 200) {
            this.customersEmailAddress = res.data.customersEmailAddress
            this.customersFirstname = res.data.customersFirstname
            this.customersId = res.data.customersId
            this.customersLastname = res.data.customersLastname
            this.customersTelephone = res.data.customersTelephone
            this.customersType = res.data.customersType
            // cache.set('customersType', res.data.customersType)
          }
        })
        .catch(err => {})
    },
    logout() {
      // 清空产品选择
      const productSelectionStore = useProductSelectionStore()
      productSelectionStore.clearSelectedProductIds()

      // 其他登出逻辑...
    },
  },
})
